import Http from '../../../../network/Http';
import {NatGetFacilityIntroductory} from './NatGetFacilityIntroductory';
import {
    NatPutFacilityIntroductory,
    NatPutFacilityIntroductoryParams
} from '../../facility/repository/NatPutFacilityIntroductory';
import {FacilitiesForPagination} from '../../../../components/facilities/FacilitiesRepository';
import {Nullable} from '../../../../app/TypeHelpers';
import {ApiResponse} from '../../../../network/response/ApiResponse';
import FacilityForAdmin from '../../../../components/facilities/FacilityForAdmin';
import {SortOrder} from '../../../../components/shared/SortOrder';

export default class NatFacilityRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 施設紹介文取得
    async getFacilityIntroductory(facilityId: string): Promise<NatGetFacilityIntroductory> {
        return await this.http.get(`/api/admin/facility/introductory/${facilityId}`)
    }

    // 施設紹介文更新
    async putFacilityIntroductory(
        messageEditParams: NatPutFacilityIntroductoryParams): Promise<NatPutFacilityIntroductory> {
        return await this.http.put(
            `/api/admin/facility/introductory/${messageEditParams.facilityId}`, messageEditParams);
    }

    // 設備取得
    async getNatFacilitiesForAdmin(
        condominiumCd: string,
        categoryId: Nullable<string>,
        searchConditionSortInfos: Nullable<SortOrder[]>,
        paginationParam?: { limit: number, offset: number },
    ): Promise<FacilitiesForPagination> {
        const queries: string[] = []

        if (categoryId !== null) {
            queries.push(`category-id=${categoryId}`)
        }

        if (searchConditionSortInfos) {
            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                queries.push(`sortInfo=${value}`)
            })
        }

        if (paginationParam) {
            queries.push(`limit=${paginationParam.limit}`)
        }

        if (paginationParam) {
            queries.push(`offset=${paginationParam.offset}`)
        }

        let queryString: string = '';
        if (queries.length !== 0) {
            queryString = '?' + queries.join('&')
        }

        const response: ApiResponse<FacilitiesForPagination> =
            await this.http.get(`/api/admin/condominiums/${condominiumCd}/facilities${queryString}`);
        const apiResponse: ApiResponse<FacilitiesForPagination> =
            ApiResponse.fromContentsForPagination(response, FacilityForAdmin.from);
        return apiResponse.details
    }
}
